import { FieldValues, UseFormWatch } from 'react-hook-form';

import validateRegExp from '@/utils/validateRegExp';

import DescriptionPasswordItem from './DescriptionPasswordItem';

/**
 * name: form 필드 이름
 * watch: form 필드 감시 객체
 * styleWidthSize: 너비
 */
type Props = {
  name: string;
  watch: UseFormWatch<FieldValues>;
  styleWidthSize?: string;
};

const ValidateItems = [
  {
    label: '영문',
    regExpFunc: (value: string) => validateRegExp('eng_contain', value),
  },
  {
    label: '숫자',
    regExpFunc: (value: string) => validateRegExp('num_contain', value),
  },
  {
    label: '특수문자',
    regExpFunc: (value: string): boolean => validateRegExp('special', value),
  },
  {
    label: '8자리 이상',
    regExpFunc: (value: string) => !!(value && value.length >= 8),
  },
];

export default function DescriptionPassword({
  name,
  watch,
  styleWidthSize = 'auto',
}: Props) {
  const value = watch(name);
  const hasValue = !!value;

  return (
    <div
      className="flex flex-shrink-0 flex-wrap items-start gap-x-2 gap-y-0 pt-1"
      style={{ width: styleWidthSize }}
    >
      {ValidateItems.map((item) => {
        return (
          <DescriptionPasswordItem
            isValid={hasValue && item.regExpFunc(value)}
            key={name + item.label}
          >
            {item.label}
          </DescriptionPasswordItem>
        );
      })}
    </div>
  );
}
